import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, FormControl, FormHelperText, Input, InputAdornment, InputBase, inputBaseClasses, InputLabel, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledFormControl = styled(FormControl)(function (_ref) {
  var fullWidth = _ref.fullWidth;
  var styles = {
    display: fullWidth && 'flex',
    maxWidth: '100%'
  };
  return styles;
});
var StyledInputBase = styled(InputBase)(function (_ref2) {
  var _styles;

  var theme = _ref2.theme,
      color = _ref2.color,
      type = _ref2.type;
  var styles = (_styles = {
    '& input::placeholder': {
      color: type === 'search' ? theme.colors.comet : theme.colors.frenchGray,
      opacity: 1
      /* Firefox */

    },
    border: 'none',
    borderRadius: pxToRem(14),
    overflow: 'hidden',
    backgroundColor: theme.colors.whisper,
    'input[type="search"]::-webkit-search-cancel-button': {
      display: 'none'
    }
  }, _defineProperty(_styles, "& .".concat(inputBaseClasses.input), {
    boxSizing: 'border-box',
    height: theme.typography.pxToRem(48),
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(20),
    fontWeight: 500,
    letterSpacing: '-0.003em',
    color: theme.colors.mineShaft,
    padding: theme.spacing(1.75, 2),
    position: 'relative',
    backgroundColor: theme.colors.whisper,
    caretColor: theme.colors.funGreen
  }), _defineProperty(_styles, '&: hover', {
    borderColor: theme.colors.funGreen
  }), _defineProperty(_styles, "&.".concat(inputBaseClasses.focused), {
    borderColor: theme.colors.funGreen,
    outline: "1px solid ".concat(theme.colors.seaGreen)
  }), _defineProperty(_styles, "&.".concat(inputBaseClasses.error), {
    borderColor: theme.colors.bitterSweet,
    outline: "1px solid ".concat(theme.colors.bitterSweet)
  }), _defineProperty(_styles, "&.".concat(inputBaseClasses.disabled), {
    color: theme.colors.ghost
  }), _styles);
  return styles;
});
var StyledInput = styled(Input)(function (_ref3) {
  var theme = _ref3.theme,
      color = _ref3.color;
  var styles = {
    '& .MuiSvgIcon-root': {
      width: pxToRem(10),
      height: pxToRem(10),
      svg: {
        width: pxToRem(10),
        height: pxToRem(10)
      }
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(0.5, 0),
      fontSize: pxToRem(12)
    }
  };
  return styles;
});
var StyledInputLabel = styled(InputLabel)(function (_ref4) {
  var theme = _ref4.theme;

  var styles = _defineProperty({
    position: 'relative',
    transform: 'unset',
    transformOrigin: 'unset',
    maxWidth: '100%',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    fontWeight: 400,
    color: theme.colors.comet,
    letterSpacing: '-0.0015em',
    display: 'block',
    whiteSpace: 'unset',
    paddingLeft: theme.spacing(0.5)
  }, "&.".concat(inputBaseClasses.focused), {
    color: theme.colors.comet
  });

  return styles;
});
var StyleFormHelperWrapper = styled(Box)(function (_ref5) {
  var theme = _ref5.theme;
  var styles = {
    marginTop: theme.typography.pxToRem(4),
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(14),
    zIndex: 1
  };
  return styles;
});
var StyledFormHelperErrorText = styled(FormHelperText)(function (_ref6) {
  var theme = _ref6.theme;
  var styles = {
    color: theme.colors.bitterSweet,
    display: 'block',
    padding: theme.spacing(0, 2),
    margin: 'unset',
    maxWidth: '100%',
    textAlign: 'center',
    '&.Mui-error': {
      color: theme.colors.bitterSweet
    }
  };
  return styles;
});
var StyledFormHelperText = styled(FormHelperText)(function (_ref7) {
  var theme = _ref7.theme;
  var styles = {
    fontSize: pxToRem(13),
    lineHeight: pxToRem(18),
    paddingLeft: pxToRem(24),
    paddingRight: pxToRem(24),
    textAlign: 'center',
    color: theme.colors.raven,
    display: 'block',
    margin: 'unset',
    maxWidth: '100%'
  };
  return styles;
});
var StyledInputEndAdornment = styled(InputAdornment)(function (_ref8) {
  var theme = _ref8.theme;
  var styles = {
    marginRight: 'unset',
    backgroundColor: theme.colors.whisper,
    padding: "".concat(pxToRem(24), " ").concat(pxToRem(12), " ").concat(pxToRem(24), " 0")
  };
  return styles;
});
var StyledClearableInputEndAdornment = styled(InputAdornment)(function (_ref9) {
  var theme = _ref9.theme;
  var styles = {
    marginRight: 'unset',
    backgroundColor: theme.colors.whisper,
    padding: "".concat(pxToRem(24), " 0 ").concat(pxToRem(24), " 0"),
    position: 'absolute',
    right: pxToRem(6),
    zIndex: '9999999'
  };
  return styles;
});
var StyledInputStartAdornment = styled(InputAdornment)(function (_ref10) {
  var theme = _ref10.theme;
  var styles = {
    marginRight: 'unset',
    backgroundColor: theme.colors.whisper,
    padding: "".concat(pxToRem(24), " 0 ").concat(pxToRem(24), " ").concat(pxToRem(12))
  };
  return styles;
});
export { StyledClearableInputEndAdornment, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyledInput, StyledInputBase, StyledInputEndAdornment, StyledInputLabel, StyledInputStartAdornment, StyleFormHelperWrapper };